import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContactUsRequestModel } from 'app/generated/backend/crm/api/contact-us-request-model';
import { ContactUsResponseModel } from 'app/generated/backend/crm/api/contact-us-response-model';

@Injectable()
export class ContactUsHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: ContactUsRequestModel
	): Observable<JsonResourceResponse<ContactUsResponseModel>> {
		return this.http.post<JsonResourceResponse<ContactUsResponseModel>>('api/crm/contactUs', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ContactUsHandlerService
	]
})
export class ContactUsHandlerModule { }
